import PropTypes from "prop-types"
import { useEffect } from "react"
import { Helmet } from "react-helmet-async"
import { connect } from "react-redux"

import { checkAppleGooglePay, initCart } from "areas/cart/store/actions"
import { jewlr_t } from "helpers/application"

export default function fetchCart(WrappedComponent) {
  const InternalComponentName = ({
    checkAppleGooglePay,
    loadCart,
    ...props
  }) => {
    useEffect(() => {
      loadCart()
      if (sl.config.enable_apple_google_pay) {
        checkAppleGooglePay()
      }
    }, [])

    return (
      <>
        <Helmet>
          <title>
            Shopping {jewlr_t("Cart")} | Custom Made {jewlr_t("terms.Jewelry")}
          </title>
          <meta
            content={`Shopping ${jewlr_t("Cart")} for custom necklaces, rings, earrings, and bracelets made from high-quality, personalized materials and gemstones for men and women, from Jewlr.`}
            name="description"
          />
          <meta
            content={`Shopping ${jewlr_t("Cart")} for custom necklaces, rings, earrings, and bracelets made from high-quality, personalized materials and gemstones for men and women, from Jewlr.`}
            property="og:description"
          />
        </Helmet>
        <WrappedComponent {...props} />
      </>
    )
  }

  const mapStateToProps = () => {
    return {}
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      checkAppleGooglePay: () => {
        dispatch(checkAppleGooglePay())
      },
      loadCart: () => {
        dispatch(initCart())
      },
    }
  }

  InternalComponentName.propTypes = {
    checkAppleGooglePay: PropTypes.func,
    loadCart: PropTypes.func,
  }

  const ComponentName = connect(
    mapStateToProps,
    mapDispatchToProps
  )(InternalComponentName)

  return ComponentName
}
